'use client';

import { Box, HStack, Icon, Text } from '@chakra-ui/react';
import { ListChecks, MessageCircleQuestion } from 'lucide-react';
import type {
  ResearchExecutionMode,
  ResearchRunPhase,
} from '@/lib/research-assistant/runtime/run-controller';

export function RunModeComposerContext({
  mode,
  phase,
}: {
  mode: Exclude<ResearchExecutionMode, 'standard'>;
  phase: Extract<ResearchRunPhase, 'awaiting_user' | 'awaiting_approval'>;
}) {
  const needsAnswers = phase === 'awaiting_user';

  return (
    <HStack
      px={{ base: '3.5', md: '4' }}
      py="2.5"
      gap="2.5"
      borderTopRadius="calc(var(--composer-radius, 20px) - 1px)"
      flexShrink={0}
      minW={0}
      borderBottomWidth="1px"
      borderBottomColor="ui.border.subtle"
      bg="accent.traceSurface"
      align="center"
    >
      <Box
        boxSize="6"
        borderRadius="full"
        bg="accent.solid"
        color="accent.contrast"
        display="grid"
        placeItems="center"
        flexShrink={0}
      >
        <Icon boxSize="3.5">{needsAnswers ? <MessageCircleQuestion /> : <ListChecks />}</Icon>
      </Box>
      <Text minW={0} fontSize="xs" lineHeight="1.4" color="ui.text.secondary">
        <Text as="span" fontWeight="750" color="ui.text.primary">
          {mode === 'plan' ? 'Plan' : 'Goal'} mode {needsAnswers ? 'needs your input.' : 'is on.'}
        </Text>{' '}
        {needsAnswers
          ? 'Reply with answers to the questions above.'
          : 'Reply with changes, or type “approve” to start.'}
      </Text>
    </HStack>
  );
}
